import { ColDef, ICellRendererParams, ValueGetterParams, ValueFormatterParams } from "ag-grid-community";
import React, { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { UtilityService } from "../../../services/UtilityService";
import { AppRoutes } from "../../routes/route.path";
import { ActionLabels, GridStatusLabelVariant, buttonLabels, emptyLabels, pageTitles } from "../../shared/constants";
import { ActionsRenderer } from "../../shared/grid/actionsRenderer";
import { HeaderTemplate, dateComparator } from "../../shared/grid/grid.services";
import { StatusRenderer } from "../../shared/grid/statusRenderer";
import { AddOrgIcon, EditIcon } from "../../../icon";
import { ChannelOrganizationModel, mapToChannelOrganization } from "../../../models/channels/channels.model";
import { ChannelService } from "../../../services/channels/ChannelAcountService";
import PageHeaderComponent from "../../shared/page-header.component";
import GridComponent from "../../shared/grid";
import { CustomFilterCategory } from "../../shared/filters/filter.model";
import FilterComponent from "../../shared/filters/filter.component";
import { Popover } from "@mui/material";
import _ from 'lodash';
import AddChannelOrganization from "./channels-add-organization";
import { useDispatch } from "react-redux";
import { useSelector } from 'react-redux';
import * as selector from '../../../selectors/selectors';
import { LoadAllChannelOrganizations } from "../../../actions";
import { setHeaderTitle, setRefreshHandler } from "../../../helpers/header.helper";

const ChannelAllOrganisations: React.FC = () => {

    const dispatch = useDispatch()
    const ChannelOrganizations: ChannelOrganizationModel[] = useSelector(selector.ChannelAllOrganizations)
    const [gridApi, setGridApi] = useState<any>(null)
    const [anchorEl, setAnchorEl] = useState<Element | null>(null)
    const [ShowFilterOptions, setShowFilterOptions] = useState<boolean>(false)
    const [viewOrganization, setViewOrganization] = useState<boolean>(false)
    const [IsEdit, setIsEdit] = useState<boolean>(false)

    const [filterOptions, setFilterOptions] = useState<CustomFilterCategory[]>([]);
    const [appliedfilters, setappliedfilters] = useState<ChannelOrganizationModel[]>([]);
    const [selectedFilterOptions, setSelectedFilterOptions] = useState<number | null>();
    const [selectedFilterTypes, setSelectedFilterTypes] = useState<string[]>([]);
    const [selectedOrganization, setSelectedOrganization] = useState<ChannelOrganizationModel>(null)


    const OrgColoumnDefs: ColDef[] = [
        {
            field: "Name",
            headerName: "Organization Name",
            cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
            minWidth: 150,
            maxWidth: 300,
            suppressSizeToFit: true
        },
        {
            field: "Email",
            headerName: "Email",
            cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
            minWidth: 200,
            suppressSizeToFit: true
        },
        {
            field: "User_Count",
            headerName: "Users",
            autoHeight: true,
            minWidth: 80,
            maxWidth: 80,
            cellRenderer: (params: ICellRendererParams) => {
                const State = { OrganizationName: params.data.Name }
                return <Link to={AppRoutes.CHANNELS_USERS} state={State} className="color-vigenary-light">{params.data.User_Count}</Link>
            },
            suppressSizeToFit: true
        },
        {
            field: "Plan_Name",
            headerName: "PlanName",
            autoHeight: true,
            minWidth: 70,
            maxWidth: 180,
            valueGetter: (params: ValueGetterParams) => {
                return params.data.PlanName
            },
            suppressSizeToFit: true
        },
        {
            field: "Plan_Type",
            headerName: "PlanType",
            autoHeight: true,
            minWidth: 70,
            maxWidth: 120,
            valueGetter: (params: ValueGetterParams) => {
                return params.data.PlanType
            },
            suppressSizeToFit: true
        },
        {
            field: "status",
            headerName: "Status",
            headerComponentParams: {
                template: selectedFilterTypes.includes("Status") ? `${HeaderTemplate.filterApplied(true)}` : ""
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                if (params.data) {
                    const label = params.data.Status === 1 ? "Active" : "   Inactive";
                    const variant = params.data.Status === 2 ? GridStatusLabelVariant.Danger : GridStatusLabelVariant.Active;
                    const Status = {
                        component: StatusRenderer,
                        params: {
                            Variant: variant, Label: label, Id: params.data.ID
                        }
                    }
                    return Status
                }
                return undefined
            },
            suppressSizeToFit: true,
            minWidth: 100,
            width: 100,
            maxWidth: 100,
        },
        {
            field: "created_at",
            headerName: "Added Date",
            valueFormatter: (params: ValueFormatterParams) => {
                return UtilityService.convertDateToDay(params.value).toString()
            },
            valueGetter: (params: ValueGetterParams) => {
                return UtilityService.convertDateToDay(params.data.Created_At).toString()
            },
            minWidth: 150,
            width: 150,
            maxWidth: 150,
            suppressSizeToFit: true
        },
        {
            field: "added_by",
            headerName: "Added By",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.Added_By
            },
            sort: 'desc',
            comparator: (valueA, valueB, nodeA, nodeB) => dateComparator(nodeA.data.Created_At, nodeB.data.Created_At),
            minWidth: 150,
            width: 150,
            maxWidth: 150,
            suppressSizeToFit: true
        },
        {
            field: "Action",
            maxWidth: 40,
            headerName: "",
            pinned: "right",
            lockPinned: true,
            lockPosition: "right",
            cellClass: "ag-cell-actions-style",
            headerClass: "bg-color-secondary",
            cellRenderer: params =>
                <ActionsRenderer
                    MenuData={getMenuActions(params.data)}
                    {...params}
                />,
            resizable: false,
            sortable: false,
        },
    ]

    const getMenuActions = (data: ChannelOrganizationModel) => {
        return [
            {
                Name: ActionLabels.EDIT,
                Icon: EditIcon,
                OnClick: () => { handleOrganizationEdit(data) },
            },
        ]
    }

    const handleOrganizationEdit = (data) => {
        setViewOrganization(true)
        setSelectedOrganization(data)
    }

    useEffect(() => {
        LoadAllChannelOrganizations(dispatch)
        setHeaderTitle("ChannelAllOrganizations")
        setRefreshHandler(() => refreshData())
    }, [])


    const refreshData = () => {
        if (!!gridApi) {
            gridApi.refreshCells({ force: true })
            gridApi.deselectAll();
        }
        LoadAllChannelOrganizations(dispatch)
    }

    const addOrg = () => {
        setViewOrganization(true);
        setIsEdit(false);
    }

    const searchOrganizations = (e: any) => {
        gridApi?.setQuickFilter(e.target.value)
    }

    const getGridTitle = () => {

        if (ChannelOrganizations?.length === 1) {
            return "1 Organization"
        }
        else {
            return ChannelOrganizations?.length + " " + pageTitles.Organizations
        }
    }

    const onGridReady = (params) => {
        setGridApi(params.api)
    }

    const handleCloseFilter = () => {
        setAnchorEl(null);
        setShowFilterOptions(false);
    }

    const handleApplyFilters = (filters) => {
        setFilterOptions(filters);
        const { result } = UtilityService.getFilterTypes(filters);
        setSelectedFilterTypes(result)
    };

    const handleClickFilter = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }
    const initialFilterOptions = () => {
        const filterData: CustomFilterCategory[] = [
            {
                Id: 1,
                Title: "Status",
                IsSelectedAll: false,
                Options: _((ChannelOrganizations).map((row) => {
                    return {
                        Key: "Status",
                        Id: row.ID,
                        Label: row.Status === 1 ? "Active" : "Inactive",
                        Value: row.Status,
                        IsSelected: false,
                    }
                })).unionBy("Label")
                    .value(),
            }
        ]
        setFilterOptions(filterData)

    }

    useEffect(() => {
        initialFilterOptions()
    }, [ChannelOrganizations])

    const closeViewOrg = (refresh?: boolean) => {
        setViewOrganization(false);
        setIsEdit(false);
        setSelectedOrganization(null)
        if (refresh) {
            LoadAllChannelOrganizations(dispatch)
        }
    }

    return (
        <div className="w-p-100 h-p-100">
            <div className="d-flex flex-direction h-p-100 o-hidden justify-between">
                <PageHeaderComponent
                    Reload={() => LoadAllChannelOrganizations(dispatch)}
                    Actions={[{
                        OnClick: () => addOrg(),
                        ButtonLabel: buttonLabels.ADD_ORGANIZATION,
                        Icon: AddOrgIcon,
                        Variant: "primary-btn",
                    }]}
                    PlaceHolder={"Search..."}
                    onSearch={searchOrganizations}
                    GridTitle={getGridTitle()}
                    Count={ChannelOrganizations.length}
                    ShowFilterIcon={true}
                    IsFilterApplied={filterOptions.flatMap(x => x.Options.filter(x => x.IsSelected)).length}
                    HandleFilter={handleClickFilter}
                />

                <GridComponent
                    ColumnDefs={OrgColoumnDefs}
                    RowData={ChannelOrganizations}
                    OnGridReady={onGridReady}
                    IsPaginationEnabled={true}
                    EmptyLabel={emptyLabels.ORGANIZATION}
                    gridApi={gridApi}
                    LockVisible={false}
                    filterOptions={filterOptions}
                />

                {viewOrganization &&
                    <AddChannelOrganization ViewOrganization={viewOrganization} handleClose={closeViewOrg} SelectedOrganizationId={!!selectedOrganization?.ID ? selectedOrganization?.ID : ""} IsEdit={!!selectedOrganization?.ID} Org_Details={{ Name: !!selectedOrganization?.Name ? selectedOrganization?.Name : "", Email: !!selectedOrganization?.Email ? selectedOrganization?.Email : "" }} />
                }
            </div>

            {
                Boolean(anchorEl) &&

                <Popover
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    onClose={handleCloseFilter}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    classes={{ paper: `min-w-40 ${ShowFilterOptions ? "min-h-40" : ""}` }}
                >
                    <FilterComponent
                        Filters={filterOptions}
                        HandleApplyFilters={handleApplyFilters}
                        OnClose={handleCloseFilter}
                    />
                </Popover>
            }
        </div>
    )
}

export default ChannelAllOrganisations;